module.exports = __webpack_public_path__ + "static/media/professionals.b1716a7d.jpg";